<template>
  <div class="shuzhi-national-map-container">
    <!-- 标题区域 -->
    <div class="header">
        <h1>全国布局 数智服务</h1>
        <p>30余家分支机构 · 数智化服务网络</p>
    </div>

    <!-- 地图区域 -->
    <div class="map-section">
        <div id="mapContainer"></div>
        <div class="legend">
            <div class="legend-item">
                <span class="legend-label office">分公司</span>
            </div>
            <div class="legend-item">
                <span class="legend-label branch">办事处</span>
            </div>
            <div class="legend-item">
                <span class="legend-label star">公司总部</span>
            </div>
        </div>
    </div>

    <!-- 右侧信息面板 -->
    <div :class="['info-panel', { active: panelVisible }]">
        <div class="panel-close" @click.prevent="closePanel">×</div>
        <div class="panel-header">
            <h2 class="panel-title">{{ activeBranch ? activeBranch.name : '分支机构' }}</h2>
            <p class="panel-subtitle">{{ activeBranch ? activeBranch.displaySubtitle : '详细信息' }}</p>
        </div>
        <div class="panel-content">
            <div class="panel-section">
                <h3 class="section-title">基本信息</h3>
                <div class="info-item">
                    <div class="info-icon">🏢</div>
                    <div class="info-text">
                        <div class="info-label">营业名称</div>
                        <div class="info-value">{{ activeBranch ? activeBranch.license : '-' }}</div>
                    </div>
                </div>
                <div class="info-item">
                    <div class="info-icon">👤</div>
                    <div class="info-text">
                        <div class="info-label">负责人</div>
                        <div class="info-value">{{ activeBranch ? activeBranch.manager : '-' }}</div>
                    </div>
                </div>
            </div>

            <div class="panel-section">
                <h3 class="section-title">地址信息</h3>
                <div class="info-item">
                    <div class="info-icon">📍</div>
                    <div class="info-text">
                        <div class="info-label">办公地址</div>
                        <div class="info-value">{{ activeBranch ? activeBranch.address : '-' }}</div>
                    </div>
                </div>
                <div class="info-item">
                    <div class="info-icon">🎯</div>
                    <div class="info-text">
                        <div class="info-label">服务区域</div>
                        <div class="info-value">{{ activeBranch ? activeBranch.serviceArea : '-' }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import chinaJson from '@/assets/index/100000_full.json';

export default {
  name: 'NationalMap',
  data() {
    return {
      chart: null,
      chinaJson: null,
      branches: [
            { id: 1, name: '江苏分公司', lng: 118.767413, lat: 32.041544, manager: '汪澄', phone: '13770516177', address: '南京市玄武区珠江路498号未来城B座311室', license: '瑞和安惠项目管理集团有限公司江苏分公司', serviceArea: '江苏省内', projectCount: '120+', totalAmount: '2.8亿元', typicalProject: '南京江北新区基础设施项目、苏州工业园区建设项目', type: 'office', level: '省级' },
            { id: 2, name: '河南分公司', lng: 113.625368, lat: 34.7466, manager: '琚海业', phone: '13937197076', address: '郑州市金水区绿地原盛国际一号楼14层', license: '瑞和安惠项目管理集团有限公司河南分公司', serviceArea: '河南省内', projectCount: '95+', totalAmount: '1.9亿元', typicalProject: '郑州轨道交通项目、洛阳新区建设项目', type: 'office', level: '省级' },
            { id: 3, name: '苏州分公司', lng: 120.619585, lat: 31.299379, manager: '王燕鸣', phone: '13862572228', address: '苏州市虎丘区运河路99号5楼', license: '瑞和安惠项目管理集团有限公司苏州分公司', serviceArea: '苏州市内', projectCount: '68+', totalAmount: '1.2亿元', typicalProject: '苏州高新区科技园、吴江区民生工程', type: 'office', level: '市级' },
            { id: 4, name: '安徽办事处', lng: 117.227239, lat: 31.820587, manager: '徐必刚', phone: '15555192249', address: '安徽省合肥市瑶海区银通物联中心A座1303室', license: '无', serviceArea: '安徽省内', projectCount: '35+', totalAmount: '6000万元', typicalProject: '合肥市政道路工程、芜湖产业园区项目', type: 'branch', level: '/' },
            { id: 5, name: '天津办事处', lng: 117.190182, lat: 39.125596, manager: '郭姗', phone: '15900370950', address: '天津滨海高新区塘沽海洋科技园信安创业广场10号楼507', license: '瑞和安惠项目管理集团有限公司天津分公司', serviceArea: '天津市内', projectCount: '42+', totalAmount: '8500万元', typicalProject: '天津滨海新区项目、滨海高新区配套工程', type: 'branch', level: '/' },
            { id: 6, name: '南昌办事处', lng: 115.857962, lat: 28.682892, manager: '付监平', phone: '15170014110', address: '南昌市青山湖区中节能国际中心1号楼1503', license: '无', serviceArea: '江西省内（中介超市）', projectCount: '28+', totalAmount: '4500万元', typicalProject: '南昌市政改造项目、赣州高铁新区项目', type: 'branch', level: '/' },
            { id: 7, name: '海口办事处', lng: 110.198928, lat: 20.017756, manager: '勃海锋', phone: '13698909650', address: '海口市龙华区滨濂路金鹿雅苑小区', license: '无', serviceArea: '海南北部及南部乐东、万宁、陵水、东方', projectCount: '25+', totalAmount: '5200万元', typicalProject: '海南自贸港建设项目、三亚旅游设施项目', type: 'branch', level: '/' },
            { id: 8, name: '商丘办事处', lng: 115.650625, lat: 34.414528, manager: '庄严', phone: '13903707833', address: '商丘市睢阳区神火大道府前花园小区B栋3楼', license: '无', serviceArea: '河南商丘市', projectCount: '18+', totalAmount: '2800万元', typicalProject: '商丘示范区项目、睢阳区老旧小区改造', type: 'branch', level: '/' },
            { id: 9, name: '湖北分公司', lng: 114.298572, lat: 30.584355, manager: '郑俊', phone: '15071325725', address: '湖北省武汉市武昌区中北路楚天都市花园B座19楼C3', license: '瑞和安惠项目管理集团有限公司湖北分公司', serviceArea: '湖北省内', projectCount: '88+', totalAmount: '1.6亿元', typicalProject: '武汉光谷建设项目、襄阳高新区项目', type: 'office', level: '省级' },
            { id: 10, name: '海南分公司', lng: 109.733755, lat: 18.522009, manager: '刘新宇', phone: '13603117709', address: '三亚市吉阳区凤凰路1号金元椰景蓝岸sv5 -301', license: '瑞和安惠项目管理集团有限公司海南分公司', serviceArea: '海南省', projectCount: '56+', totalAmount: '1.1亿元', typicalProject: '海南自贸区基础设施、三亚国际旅游岛项目', type: 'office', level: '省级' },
            { id: 11, name: '成都分公司', lng: 104.066541, lat: 30.572269, manager: '温蕤', phone: '18683678897', address: '成都市武侯区西部智谷D区5栋2单元803', license: '瑞和安惠项目管理集团有限公司成都分公司', serviceArea: '成都市', projectCount: '75+', totalAmount: '1.5亿元', typicalProject: '成都天府新区项目、高新区产业园区', type: 'office', level: '市级' },
            { id: 12, name: '泸州分公司', lng: 105.443975, lat: 28.87176, manager: '刘星', phone: '13458738333', address: '泸州市江阳区华升南路欢乐汇B塔楼1408室', license: '瑞和安惠项目管理集团有限公司泸州分公司', serviceArea: '泸州市', projectCount: '38+', totalAmount: '7200万元', typicalProject: '泸州白酒产业园区、长江经济带项目', type: 'office', level: '市级' },
            { id: 13, name: '长沙分公司', lng: 112.982279, lat: 28.19409, manager: '曹云', phone: '15674899060', address: '长沙市岳麓区振业城3期B区公寓A座19楼', license: '无', serviceArea: '长沙市', projectCount: '52+', totalAmount: '9800万元', typicalProject: '长沙梅溪湖项目、湘江新区建设项目', type: 'office', level: '市级' },
            { id: 14, name: '太原分公司', lng: 112.548879, lat: 37.87059, manager: '高柯', phone: '13485374994', address: '太原市迎泽区双塔西街50号安业商务楼C座306室', license: '瑞和安惠项目管理集团有限公司太原分公司', serviceArea: '大同、长治、阳泉、吕梁', projectCount: '48+', totalAmount: '8900万元', typicalProject: '太原城市更新项目、大同能源基地项目', type: 'office', level: '市级' },
            { id: 15, name: '开封分公司', lng: 114.307486, lat: 34.797108, manager: '孙花', phone: '18937168027', address: '河南省开封市郑开大道与集英街交叉口西北角开元上城金座1307室', license: '瑞和安惠项目管理集团有限公司开封分公司', serviceArea: '开封市', projectCount: '32+', totalAmount: '5800万元', typicalProject: '开封古城保护项目、郑开同城化项目', type: 'office', level: '市级' },
            { id: 16, name: '葫芦岛分公司', lng: 120.836393, lat: 40.742965, manager: '周玉才', phone: '18842947555', address: '辽宁省葫芦岛市绥中光明花苑4号楼4单元301', license: '无', serviceArea: '葫芦岛市', projectCount: '22+', totalAmount: '4100万元', typicalProject: '葫芦岛港口项目、绥中滨海经济区', type: 'office', level: '市级' },
            { id: 17, name: '重庆分公司', lng: 106.551556, lat: 29.563009, manager: '袁胜金', phone: '18696533281', address: '重庆市沙坪坝区西双大道16号', license: '瑞和安惠项目管理集团有限公司重庆分公司', serviceArea: '重庆市', projectCount: '65+', totalAmount: '1.3亿元', typicalProject: '重庆两江新区项目、成渝双城经济圈项目', type: 'office', level: '市级' },
            { id: 18, name: '南昌造价分公司', lng: 115.892151, lat: 28.676493, manager: '魏付平', phone: '18921122183', address: '南昌市西湖区星河国际930', license: '瑞和安惠项目管理集团有限公司南昌分公司', serviceArea: '南昌市', projectCount: '45+', totalAmount: '8200万元', typicalProject: '南昌市政项目、赣江新区建设项目', type: 'office', level: '市级' },
            { id: 19, name: '通辽分公司', lng: 122.243147, lat: 43.617429, manager: '马旭', phone: '16621194858', address: '内蒙古通辽市凤凰山达街中段，檀香湾一期北侧', license: '无', serviceArea: '通辽市', projectCount: '15+', totalAmount: '2900万元', typicalProject: '通辽能源项目、蒙东物流园区', type: 'office', level: '市级' },
            { id: 20, name: '焦作分公司', lng: 113.241782, lat: 35.215865, manager: '易元清', phone: '15093725050', address: '河南省焦作市解放区王储街道办事处普希顿小区19号楼附5号2层202室', license: '瑞和安惠项目管理集团有限公司焦作分公司', serviceArea: '焦作市', projectCount: '28+', totalAmount: '5100万元', typicalProject: '焦作云台山项目、太极文化产业园', type: 'office', level: '市级' },
            { id: 21, name: '郑州分公司（咨询）', lng: 113.625368, lat: 34.7466, manager: '蔡俊杰', phone: '18003710499', address: '郑州市管城区长江东路鑫苑城三号院', license: '瑞和安惠项目管理集团有限公司郑州分公司', serviceArea: '郑州市', projectCount: '78+', totalAmount: '1.4亿元', typicalProject: '郑州航空港区项目、中原科技城项目', type: 'office', level: '市级' },
            { id: 22, name: '长春分公司', lng: 125.323544, lat: 43.817071, manager: '韩志忠', phone: '0431-81853006', address: '吉林省长春市南关区鸿城国际花园小区28栋', license: '无', serviceArea: '长春市', projectCount: '35+', totalAmount: '6500万元', typicalProject: '长春新区项目、一汽配套产业园', type: 'office', level: '/' },
            { id: 23, name: '晋中分公司', lng: 112.752594, lat: 37.687166, manager: '马国彬', phone: '13834145161', address: '太原市迎泽区龙堡23号创意园区7号楼', license: '瑞和安惠项目管理集团有限公司晋中分公司', serviceArea: '晋中市', projectCount: '26+', totalAmount: '4800万元', typicalProject: '晋中开发区项目、山西转型综改区', type: 'office', level: '市级' },
            { id: 24, name: '成都市造价分公司', lng: 104.081534, lat: 30.655822, manager: '程权波', phone: '18886661801', address: '成都市锦江区榕树街37号7-1505', license: '瑞和安惠项目管理集团有限公司成都锦江分公司', serviceArea: '成都市', projectCount: '58+', totalAmount: '1.1亿元', typicalProject: '成都东客站项目、锦江区城市更新', type: 'office', level: '市级' },
            { id: 25, name: '沈阳分公司', lng: 123.431474, lat: 41.805698, manager: '李岩', phone: '13940049055', address: '辽宁省沈阳市铁西区云峰北街36号', license: '瑞和安惠项目管理集团有限公司沈阳分公司', serviceArea: '沈阳市', projectCount: '62+', totalAmount: '1.2亿元', typicalProject: '沈阳浑南新区项目、中德装备园项目', type: 'office', level: '市级' },
            { id: 26, name: '赤峰市分公司', lng: 118.886865, lat: 42.259247, manager: '沈平', phone: '13847621689', address: '内蒙古赤峰市松山区玉龙街道办事处锦绣社区锦绣花园', license: '瑞和安惠项目管理集团有限公司赤峰分公司', serviceArea: '赤峰市', projectCount: '20+', totalAmount: '3800万元', typicalProject: '赤峰红山文化项目、蒙东能源基地', type: 'office', level: '市级' },
            { id: 27, name: '菏泽分公司', lng: 115.480656, lat: 35.23375, manager: '张建国', phone: '13395309788', address: '山海天泰广场332-336', license: '瑞和安惠项目管理集团有限公司菏泽分公司', serviceArea: '菏泽市', projectCount: '30+', totalAmount: '5600万元', typicalProject: '菏泽牡丹产业项目、鲁西新区建设', type: 'office', level: '市级' },
            { id: 28, name: '阜阳分公司', lng: 115.814229, lat: 32.890852, manager: '窦海宁', phone: '13399688597', address: '安徽省阜阳市颍州区万方广场B座1305室', license: '/', serviceArea: '阜阳市内', projectCount: '24+', totalAmount: '4500万元', typicalProject: '阜阳城市圈项目、皖北承接产业转移区', type: 'office', level: '市级' },
            { id: 29, name: '济南分公司', lng: 117.1205, lat: 36.650997, manager: '刘龙、李伟莲', phone: '李伟莲15906337558', address: '日照市东港区济南路71号', license: '/', serviceArea: '济南市内', projectCount: '85+', totalAmount: '1.7亿元', typicalProject: '济南新旧动能转换项目、济南西区建设', type: 'office', level: '市级' },
            { id: 30, name: '临沂市分公司', lng: 118.326443, lat: 35.104531, manager: '邱玲', phone: '19153909222', address: '临沂市兰山区启阳路120号4号楼4单元302', license: '/', serviceArea: '临沂市', projectCount: '36+', totalAmount: '6200万元', typicalProject: '临沂商城项目、沂蒙红色旅游项目', type: 'office', level: '市级' },
            { id: 31, name: '银川市分公司', lng: 106.230909, lat: 38.487193, manager: '毛学锋', phone: '13995089095', address: '银川市兴庆区领秀一居11号楼3单元504室', license: '/', serviceArea: '银川区域', projectCount: '19+', totalAmount: '3600万元', typicalProject: '银川滨河新区项目、宁东能源基地', type: 'office', level: '/' },
            { id: 32, name: '昆明市分公司', lng: 102.832891, lat: 24.880095, manager: '杨晨', phone: '18208706360', address: '五华区新希望白麓城馨璟苑7栋1101', license: '瑞和安惠项目管理集团有限公司昆明分公司', serviceArea: '昆明市', projectCount: '42+', totalAmount: '7800万元', typicalProject: '昆明自贸区项目、中老铁路配套项目', type: 'office', level: '市级' },
            { id: 33, name: '大理办事处', lng: 100.268395, lat: 25.606585, manager: '许一菲、李皓', phone: '李皓18313829535', address: '云南省昆明市西山区', license: '无（未开通OA）', serviceArea: '大理市', projectCount: '12+', totalAmount: '2200万元', typicalProject: '大理古城保护项目、洱海生态治理项目', type: 'branch', level: '/' },
            { id: 34, name: '乐山分公司', lng: 103.765581, lat: 29.552191, manager: '汪宁远', phone: '18398646569', address: '乐山市市中区鹤翔路428号3幢9楼9号', license: '/', serviceArea: '乐山市', projectCount: '22+', totalAmount: '4100万元', typicalProject: '乐山大佛景区项目、成绵乐高铁项目', type: 'office', level: '市级' },
            { id: 35, name: '公司总部', lng: 114.30, lat: 38.02, manager: '胡勇', phone: '***********', address: '河北省石家庄市建设南大街269号河北师范大学科技园B座11、12层', license: '瑞和安惠项目管理集团有限公司', serviceArea: '全国', projectCount: '500+', totalAmount: '15亿元', typicalProject: '全国范围内大型基础设施项目、政府投资项目', type: 'star', level: '总部' }
        ],
      activeBranch: null,
      panelVisible: false,
      handleResize: null
    };
  },
  mounted() {
    this.initMap();
    this.handleResize = () => {
      if (this.chart) {
        this.chart.resize();
      }
    };
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.chart) {
        this.chart.dispose();
    }
  },
  methods: {
    async loadChinaMap() {
      try {
        // register imported JSON
        echarts.registerMap('china', chinaJson);
        return true;
      } catch (error) {
        console.error('加载中国地图数据失败：', error);
        alert('加载中国地图数据失败，请检查文件路径');
        return false;
      }
    },

    async initMap() {
      const success = await this.loadChinaMap();
      if (!success) return;

      try {
        const dom = document.getElementById('mapContainer');
        this.chart = echarts.init(dom);

        const provinceData = this.branches.filter(branch => branch.level === '省级' || branch.level === '总部').map(branch => ({
            name: branch.name,
            value: [branch.lng, branch.lat, 100],
            itemStyle: {
                color: branch.type === 'star' ? 'rgba(255, 215, 0, 0.3)' : 'rgba(24, 144, 255, 0.2)'
            },
            branchData: branch
        }));

        const scatterData = this.branches.filter(branch => branch.type !== 'star').map(branch => ({
            name: branch.name,
            value: [branch.lng, branch.lat, 100],
            itemStyle: {
                color: branch.type === 'office' ? '#1890ff' : '#52c41a',
                fontSize: branch.level === '省级' ? 14 : 11
            },
            symbolSize: (branch.level === '省级' || branch.level === '总部') ? 25 : 20,
            branchData: branch
        }));

        const starData = this.branches.filter(branch => branch.type === 'star').map(branch => ({
            name: branch.name,
            value: [branch.lng, branch.lat, 150],
            itemStyle: {
                color: '#FFD700'
            },
            branchData: branch
        }));

        const option = {
            backgroundColor: 'transparent',
            tooltip: {
                trigger: 'item',
                formatter: function(params) {
                    if (params.data && params.data.branchData) {
                        const branch = params.data.branchData;
                        return `
                            <div style="padding: 10px; min-width: 150px;">
                                <div style="font-size: 15px; font-weight: bold; color: #1890ff; margin-bottom: 8px;">${branch.name}</div>
                                <div style="font-size: 13px; color: #666; margin-bottom: 4px;">👤 负责人：${branch.manager}</div>
                                <div style="font-size: 12px; color: #52c41a; margin-top: 8px; font-weight: bold;">👆 点击查看详细信息</div>
                            </div>
                        `;
                    }
                    return '';
                }
            },
            geo: {
                map: 'china',
                roam: true,
                zoom: 1.25,
                label: {
                    show: false
                },
                itemStyle: {
                    areaColor: '#f0f5ff',
                    borderColor: '#1890ff',
                    borderWidth: 1
                },
                emphasis: {
                    itemStyle: {
                        areaColor: '#2a2a4a'
                    }
                }
            },
            series: [
                {
                    type: 'effectScatter',
                    coordinateSystem: 'geo',
                    symbolSize: 40,
                    rippleEffect: {
                        brushType: 'fill',
                        period: 6,
                        scale: 4
                    },
                    showEffectOn: 'render',
                    itemStyle: {
                        opacity: 0.4
                    },
                    data: provinceData,
                    label: {
                        show: false
                    },
                    silent: true,
                    zlevel: 0
                },
                {
                    type: 'effectScatter',
                    coordinateSystem: 'geo',
                    rippleEffect: {
                        brushType: 'stroke',
                        period: 4,
                        scale: 5
                    },
                    showEffectOn: 'render',
                    itemStyle: {
                        shadowBlur: 10,
                        shadowColor: '#1890ff'
                    },
                    data: scatterData,
                    label: {
                        show: true,
                        formatter: '{b}',
                        position: 'top',
                        fontSize: 12,
                        fontWeight: 'bold',
                        color: '#fff',
                        backgroundColor: 'rgba(24, 144, 255, 0.8)',
                        borderColor: '#1890ff',
                        borderWidth: 2,
                        borderRadius: 4,
                        padding: [4, 8],
                        distance: 8
                    },
                    emphasis: {
                        scale: 1.5,
                        label: {
                            show: true,
                            fontSize: 13,
                            backgroundColor: 'rgba(24, 144, 255, 1)',
                            borderColor: '#096dd9',
                            borderWidth: 2,
                            padding: [5, 10]
                        },
                        itemStyle: {
                            shadowBlur: 20,
                            shadowColor: '#1890ff'
                        }
                    }
                },
                {
                    type: 'effectScatter',
                    coordinateSystem: 'geo',
                    symbol: 'star',
                    symbolSize: 35,
                    rippleEffect: {
                        brushType: 'stroke',
                        period: 4,
                        scale: 6
                    },
                    showEffectOn: 'render',
                    itemStyle: {
                        shadowBlur: 20,
                        shadowColor: '#FFD700'
                    },
                    data: starData,
                    label: {
                        show: true,
                        formatter: '{b}',
                        position: 'bottom',
                        fontSize: 14,
                        fontWeight: 'bold',
                        color: '#FFD700',
                        backgroundColor: 'rgba(255, 255, 255, 1)',
                        borderColor: '#FFD700',
                        borderWidth: 2,
                        borderRadius: 4,
                        padding: [5, 10],
                        distance: 10
                    },
                    emphasis: {
                        scale: 1.8,
                        label: {
                            show: true,
                            fontSize: 15,
                            backgroundColor: 'rgba(255, 215, 0, 0.2)',
                            borderColor: '#FFA500',
                            borderWidth: 3,
                            padding: [6, 12]
                        },
                        itemStyle: {
                            shadowBlur: 30,
                            shadowColor: '#FFD700'
                        }
                    }
                }
            ]
        };

        this.chart.setOption(option);

        this.chart.on('click', (params) => {
            if (params.data && params.data.branchData) {
                this.showPanel(params.data.branchData);
            }
        });
      } catch (e) {
        console.error('地图初始化失败：', e);
      }
    },
    showPanel(branch) {
      this.activeBranch = branch;
      let subtitle = '';
      if (branch.level === '总部') {
          subtitle = '公司总部';
      } else if (branch.level === '/') {
          subtitle = '办事处';
      } else {
          subtitle = branch.level + '分公司';
      }
      branch.displaySubtitle = subtitle;
      this.panelVisible = true;
    },
    closePanel() {
      this.panelVisible = false;
    }
  }
}
</script>

<style lang="less">
.shuzhi-national-map-container {

        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
            background: #e6f0fa;
            color: #1a1a1a;
            overflow-x: hidden;
        }

        /* 标题区域 */
        .header {
            text-align: center;
            padding: 15px 20px;
            background: linear-gradient(135deg, #e6f0fa 0%, #f0f5ff 100%);
        }

        .header h1 {
            font-size: 36px;
            font-weight: 900;
            background: linear-gradient(135deg, #1890ff 0%, #096dd9 50%, #52c41a 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            margin-bottom: 8px;
        }

        .header p {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.55);
        }

        /* 地图区域 */
        .map-section {
            padding: 20px;
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        #mapContainer {
            width: 100%;
            max-width: 1400px;
            height: 700px;
            border-radius: 20px;
            overflow: hidden;
            box-shadow: 0 20px 60px rgba(24, 144, 255, 0.2);
            position: relative;
            z-index: 1;
            background: #e6f0fa;
        }

        /* 图例 */
        .legend {
            display: flex;
            justify-content: center;
            gap: 40px;
            margin-top: 20px;
            padding: 15px 30px;
            background: rgba(24, 144, 255, 0.1);
            border-radius: 30px;
            border: 1px solid rgba(24, 144, 255, 0.2);
        }

        .legend-item {
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.65);
        }

        .legend-label {
            padding: 4px 10px;
            border-radius: 4px;
            font-size: 12px;
            font-weight: bold;
            color: #1a1a1a;
            border: 2px solid #fff;
        }

        .legend-label.office {
            background: #1890ff;
        }

        .legend-label.branch {
            background: #52c41a;
        }

        .legend-label.star {
            background: #FFD700;
            color: #fff;
        }

        /* 右侧信息面板 */
        .info-panel {
            position: fixed;
            top: 0;
            right: -600px;
            width: 550px;
            height: 100vh;
            background: linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(245, 248, 255, 1) 100%);
            backdrop-filter: blur(20px);
            border-left: 2px solid rgba(24, 144, 255, 0.4);
            box-shadow: -10px 0 40px rgba(24, 144, 255, 0.2);
            transition: right 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
            z-index: 2000;
            overflow-y: auto;
            padding: 0;
            pointer-events: none;
        }

        .info-panel.active {
            right: 0;
            pointer-events: auto;
        }

        .panel-close {
            position: absolute;
            top: 20px;
            right: 20px;
            width: 45px;
            height: 45px;
            background: rgba(24, 144, 255, 0.15);
            border: 2px solid #1890ff;
            border-radius: 50%;
            color: #1890ff;
            font-size: 28px;
            cursor: pointer;
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            justify-content: center;
            line-height: 1;
        }

        .panel-close:hover {
            background: #1890ff;
            color: #fff;
            transform: rotate(90deg);
        }

        .panel-header {
            padding: 40px 30px 20px;
            border-bottom: 1px solid rgba(24, 144, 255, 0.15);
        }

        .panel-title {
            font-size: 28px;
            font-weight: 900;
            background: linear-gradient(135deg, #1890ff 0%, #52c41a 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            margin-bottom: 8px;
        }

        .panel-subtitle {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.45);
        }

        .panel-content {
            padding: 30px;
        }

        .panel-section {
            margin-bottom: 30px;
        }

        .section-title {
            font-size: 16px;
            font-weight: bold;
            color: #1890ff;
            margin-bottom: 15px;
            padding-bottom: 8px;
            border-bottom: 1px solid rgba(24, 144, 255, 0.15);
        }

        .info-item {
            display: flex;
            align-items: flex-start;
            gap: 12px;
            margin-bottom: 15px;
        }

        .info-icon {
            font-size: 20px;
            flex-shrink: 0;
        }

        .info-text {
            flex: 1;
        }

        .info-label {
            font-size: 12px;
            color: rgba(0, 0, 0, 0.45);
            margin-bottom: 4px;
        }

        .info-value {
            font-size: 14px;
            color: #1a1a1a;
            line-height: 1.6;
        }

    /* ========== 移动端响应式适配 ========== */
    @media screen and (max-width: 768px) {

        /* 标题区域 */
        .header {
            padding: 12px 15px;
        }

        .header h1 {
            font-size: 22px;
            margin-bottom: 4px;
        }

        .header p {
            font-size: 12px;
        }

        /* 地图区域 */
        .map-section {
            padding: 10px;
        }

        #mapContainer {
            height: 55vh;
            border-radius: 12px;
            box-shadow: 0 10px 30px rgba(24, 144, 255, 0.15);
        }

        /* 图例 */
        .legend {
            gap: 15px;
            margin-top: 12px;
            padding: 10px 15px;
            border-radius: 20px;
            flex-wrap: wrap;
        }

        .legend-item {
            font-size: 12px;
            gap: 6px;
        }

        .legend-label {
            padding: 3px 8px;
            font-size: 11px;
        }

        /* 右侧信息面板 → 移动端改为底部全宽滑出 */
        .info-panel {
            top: auto;
            bottom: -100%;
            right: 0;
            left: 0;
            width: 100%;
            height: 70vh;
            border-left: none;
            border-top: 2px solid rgba(24, 144, 255, 0.4);
            border-radius: 16px 16px 0 0;
            box-shadow: 0 -10px 40px rgba(24, 144, 255, 0.2);
            transition: bottom 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }

        .info-panel.active {
            right: 0;
            bottom: 0;
        }

        .panel-close {
            top: 12px;
            right: 12px;
            width: 36px;
            height: 36px;
            font-size: 22px;
        }

        .panel-header {
            padding: 25px 20px 15px;
        }

        .panel-title {
            font-size: 20px;
            margin-bottom: 4px;
        }

        .panel-subtitle {
            font-size: 12px;
        }

        .panel-content {
            padding: 15px 20px;
        }

        .panel-section {
            margin-bottom: 18px;
        }

        .section-title {
            font-size: 14px;
            margin-bottom: 10px;
            padding-bottom: 6px;
        }

        .info-item {
            gap: 10px;
            margin-bottom: 12px;
        }

        .info-icon {
            font-size: 16px;
        }

        .info-label {
            font-size: 11px;
        }

        .info-value {
            font-size: 13px;
        }
    }
}
</style>
